import * as Aeroexpress from './components/Aeroexpress.css';
import * as ModalContent from './components/ModalContent/ModalContent.css';
import * as CardContent from './components/CardContent/CardContent.css';

export default {
	Aeroexpress,
	ModalContent,
	CardContent
};
